import { DateInputBlock } from '@coast/schemas';
import { Range } from '@shared/components/dateAndTime/comboDatePicker/props';
import { DateString } from '@shared/scenes/cards/agenda/utils';

export enum PickerMode {
  Date = 'Date',
  Time = 'Time',
}

export interface PickerProps {
  mode: PickerMode;
  block: DateInputBlock;
  anchorName: string;
  onClose(): void;
  onChange(value: Range<DateString>): void;
}
